import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Section, Eyebrow } from "../funnel";

const FAQS = [
  ["How fast will I get funded?", "It depends on where your file starts. Clean profiles can move in weeks; files that need work take longer. We tell you honestly on day one."],
  ["Is this another course where I just watch videos?", "No. You get live calls, profile audits and a team that checks your file and tells you the next move."],
  ["Can I get in with $0 out of pocket?", "Some members qualify through our financing partners. We also have in-house payment plans. We can walk through it on a call."],
];

const Item = ({ i, q, a, open, onToggle }) => (
  <li className="border-b border-[rgba(232,184,74,0.2)]" data-testid={`faq-item-${i}`}>
    <h3>
      <button type="button" id={`faq-q-${i}`} aria-expanded={open} aria-controls={`faq-a-${i}`} onClick={onToggle} className="flex w-full items-center justify-between gap-4 py-6 text-left text-[17px] font-semibold text-[#f4efe4] transition-colors hover:text-[var(--gold)] sm:text-lg" data-testid={`faq-question-${i}`}>
        {q}
        <ChevronDown className={`h-5 w-5 shrink-0 text-[var(--gold)] transition-transform duration-300 ${open ? "rotate-180" : ""}`} aria-hidden="true" />
      </button>
    </h3>
    <div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} hidden={!open} data-testid={`faq-answer-${i}`}>
      <p className="max-w-3xl pb-6 text-[16px] leading-relaxed text-[#cfc7b6]">{a}</p>
    </div>
  </li>
);

export const Faq = () => {
  const [open, setOpen] = useState(() => new Set([1]));
  const toggle = (i) => setOpen((s) => {
    const next = new Set(s);
    next.has(i) ? next.delete(i) : next.add(i);
    return next;
  });
  return (
    <Section data-testid="faq-section">
      <div className="mx-auto max-w-3xl">
        <Eyebrow>FAQ</Eyebrow>
        <ul className="mt-6 border-t border-[rgba(232,184,74,0.2)]">
          {FAQS.map(([q, a], idx) => <Item key={q} i={idx + 1} q={q} a={a} open={open.has(idx + 1)} onToggle={() => toggle(idx + 1)} />)}
        </ul>
      </div>
    </Section>
  );
};
